import { useState } from "react";
import MedidasPreventivasForm from "./MedidasPreventivasForm";


const initialValues = {
  idMedidaPreventiva: "",
}

const MedidasPreventivasFormContainer = ({ open, handleClose, handleSubmit, selectedOptions }) => {

  const [formInitialValues, setFormInitialValues] = useState(initialValues);


  return (
    <>
      <MedidasPreventivasForm
        open={open}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        initialValues={formInitialValues}
        selectedOptions={selectedOptions}
      />
    </>
  )
}

export default MedidasPreventivasFormContainer;